import { ChevronDown } from "lucide-react";
import type { ShiftFormDocumentSettings } from "../../../shared/shift-production-form/contracts";

type DocumentMetadata = Pick<ShiftFormDocumentSettings, "documentNo" | "revisionNo"> & {
  publicationDate: string | null;
  revisionDate: string | null;
};

function documentDate(value: string | null) {
  if (!value) return "—";
  const [year, month, day] = value.split("-");
  return `${day}.${month}.${year}`;
}

function DocumentFields({ settings }: { settings: DocumentMetadata }) {
  const fields = [
    ["Doküman No", settings.documentNo ?? "—"],
    ["Yayın Tarihi", documentDate(settings.publicationDate)],
    ["Revizyon Tarihi", documentDate(settings.revisionDate)],
    ["Revizyon No", settings.revisionNo ?? "—"],
  ];
  return (
    <dl className="shift-document-info">
      {fields.map(([label, value]) => (
        <div key={label}>
          <dt>{label}</dt>
          <dd><output aria-label={label}>{value}</output></dd>
        </div>
      ))}
    </dl>
  );
}

export function ShiftFormDocumentInfo({ settings, collapsible = false }: {
  settings: DocumentMetadata;
  collapsible?: boolean;
}) {
  if (!collapsible) return <DocumentFields settings={settings} />;
  return (
    <>
      <details className="shift-document-details">
        <summary>Doküman bilgileri <ChevronDown size={14} aria-hidden="true" /></summary>
        <DocumentFields settings={settings} />
      </details>
      <div className="shift-document-print"><DocumentFields settings={settings} /></div>
    </>
  );
}
